import { BeneficiarioModel } from "../models/beneficiarioModel";
import { columns } from "../../../dtos/columns";
import { format } from "rut.js";

export function useColumnsResults() {

    const COLUMNS: columns<BeneficiarioModel>[] = [
        {
            name: 'Nombre Beneficiario',
            selector: (row: BeneficiarioModel) => row.nombreBeneficiario,
            sortable: true,
            sortField: 'nombreBeneficiario',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'RUT Beneficiario',
            selector: (row: BeneficiarioModel) => format(row.rutBeneficiario!),
            sortable: true,
            sortField: 'rutBeneficiario',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Observaciones',
            selector: (row: BeneficiarioModel) => row.erroresLiquidacion.length === 0 ?
                <>
                    La integración con SANI se realizó correctamente dentro del mismo crédito con el cliente correspondiente.
                </>
                : <ul style={{listStyleType: "circle"}}>{row.erroresLiquidacion.map((index) => <li>{index.mensaje}</li>)}
                </ul>,
            sortable: true,
            sortField: 'erroresLiquidacion',
            wrap: true,
            alling: 'left',
            export: true,
        }
    ]

    return { COLUMNS };
}